module.exports = __webpack_public_path__ + "static/media/pic-tb3.9022d23c.jpg";